import { IconButton, Icon } from '@wistia/vhs';
import { DownloadMediaFilesModal } from '~/singlePageApp/components/DownloadMediaFilesModal';
import type { JSX } from 'react';

export type DownloadMediaButtonProps = {
  mediaHashedId: string;
};

export const DownloadMediaButton = ({ mediaHashedId }: DownloadMediaButtonProps): JSX.Element => {
  return (
    <DownloadMediaFilesModal
      key="download"
      mediaHashedId={mediaHashedId}
      toggle={(onClick: () => void) => (
        <IconButton
          icon={
            <Icon
              type="download"
              size="md"
            />
          }
          preventTooltip={true}
          onClick={onClick}
          size="md"
        />
      )}
      userIsAnonymousViewer={true}
    />
  );
};
